import { registerComponent } from "helpers";
import WYATTElement from "wyatt";
import StoreAvailability from "store-availability";

registerComponent(
  "product-availability",
  class ProductAvailability extends WYATTElement {
    constructor() {
      super();

      this.StoreAvailability = new StoreAvailability(this);

      this.quantityPlaceholders = this.querySelectorAll("[data-quantity]");
      this.onPreferredStoreChange = this.handlePreferredStoreChange.bind(this);

      this.updateState();
    }

    connectedCallback() {
      this.dataset.storeNumber = this.StoreAvailability.storeNumber;

      this.subscribe(
        WYATT.PubSub.events.preferredStoreChange,
        this.onPreferredStoreChange,
      );
    }

    handlePreferredStoreChange(store) {
      this.dataset.storeNumber = store?.store_number;

      this.updateState();
    }

    async updateState() {
      this.dataset.storeNumber = this.StoreAvailability.storeNumber;

      this.dataset.availability =
        await this.StoreAvailability.getAvailability();

      const { quantityAvailable } = this.StoreAvailability;

      this.quantityPlaceholders.forEach(
        this.updateQuantityAvailable.bind(this, quantityAvailable),
      );
    }

    updateQuantityAvailable(quantityAvailable, el) {
      el.textContent = quantityAvailable;
    }
  },
);
